import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Context } from '@grandvisionhq/carts-v2';
import { useSelector, useDispatch, useStore } from '@grandvisionhq/state';
import { useCheckoutSettings } from '../../../../context/CheckoutSettings/context.js';
import '@grandvisionhq/utils';
import { useRestoreCartShippingMethod } from '../../../../hooks/carts/use-restore-cart-shipping-method.js';
import { selectShippingMethod, selectServiceStore, selectStore, selectPickupPoint } from '../../../actions.js';
import { getSelectedShippingMethod, getSelectedStore, getSelectedPickupPoint } from '../../../selectors.js';
import '@grandvisionhq/payments';
import '@grandvisionhq/auth';
import '../../../../selectors.js';
import '@grandvisionhq/common';
import '@grandvisionhq/graphql';
import '@grandvisionhq/lib-utils-cart';
import '@grandvisionhq/svc-tealium/events';
import '../../../../mappers/errors-mapping.js';
import '../../../../operations/mutations/set-customer-details.js';
import '../../../../operations/mutations/set-service-store.js';
import '../../../../operations/mutations/set-shipping-method.js';
import '../../../../operations/mutations/set-shipping-state.js';
import '../../../../operations/mutations/create-apple-pay-session.js';
import '../../../../operations/mutations/recreate-ordered-checkout.js';
import 'lodash/isEmpty';
import '../../../../utils/get-customer-details-payload.js';
import { isPickupStore, isPickupPoint } from '../../../../utils/shipping-method.js';
import 'history';
import '../../../../models/cart/cart-state.js';
import '../../../../models/checkout/checkout-step-error-type.js';
import '../../../../models/checkout-settings.js';
import { ShippingMethod } from '../../../../models/step-shipping/shipping-methods.js';
import '../../../../models/shared.js';
import '../../../../utils/has-cart-errors.js';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/fun-orders';
import '@grandvisionhq/analytics';
import '../../../../operations/fragments/checkout-mutation-result.js';
import '../../../../operations/fragments/cart-mutation-failures.js';
import '../../../../operations/fragments/recreate-ordered-checkout-failure.js';
import '../../../../operations/fragments/recreate-ordered-checkout-result.js';
import '../../../../operations/fragments/paypal-payment.js';
import '../../../../operations/fragments/saved-user-details.js';
import '../../../../operations/queries/get-checkout-state.js';
import '../../../../operations/queries/get-user-details.js';
import '@grandvisionhq/icons';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/locations';
import '../containers/PickupPointsFinderContainer.js';
import '../containers/StoresFinderContainer.js';
import { ShippingMethodsListContainer } from '../containers/ShippingMethodsListContainer.js';
import { SelectedShippingMethodContainer } from '../containers/SelectedShippingMethodContainer.js';
import { useShippingMethodSelection } from '../hooks/use-shipping-method-selection.js';
import { useShippingMethodsList } from '../hooks/use-shipping-methods-list.js';
import { shippingMethodsSuccess, shippingMethodsFailed } from '../state/actions.js';

const ShippingMethods = ({ shippingMethodsAsides  })=>{
    const { shipping , features  } = useCheckoutSettings();
    const selectedShippingMethod1 = useSelector(getSelectedShippingMethod);
    const dispatch = useDispatch();
    const { cart  } = Context.useCart();
    const store1 = useStore();
    const selectedStore = useSelector(getSelectedStore);
    const selectedPickupPoint = useSelector(getSelectedPickupPoint);
    const { restoreShippingMethod  } = useRestoreCartShippingMethod();
    /**
   *  Success handler for shippingMethodForCart query operation
   */ const onShippingMethodsLoadCompleted = React.useCallback((shippingMethodList)=>{
        const selectedShippingMethod = getSelectedShippingMethod(store1.getState());
        const isSelectedShippingMethodValid = shippingMethodList.find((method)=>{
            return (selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method) == method.key;
        });
        if ((selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method) && !isSelectedShippingMethodValid) {
            dispatch(selectShippingMethod({
                shippingMethod: {
                    method: undefined,
                    isValid: false,
                    isTouched: true
                }
            }));
        } else if (cart && (cart === null || cart === void 0 ? void 0 : cart.shippingMethod.key) !== (selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method)) {
            if (cart === null || cart === void 0 ? void 0 : cart.shippingMethod.key) {
                dispatch(selectShippingMethod({
                    shippingMethod: {
                        method: cart === null || cart === void 0 ? void 0 : cart.shippingMethod.key,
                        isValid: true,
                        isTouched: false
                    }
                }));
            } else {
                // Cart has no shipping method information, try to use the actual default value
                // This happens when a feature toggle in cart-service (ADD_SHIPPING_METHOD_TO_CART) is disabled
                const defaultShippingMethod = shippingMethodList.find((method)=>method.isDefault
                );
                if (defaultShippingMethod) {
                    dispatch(selectShippingMethod({
                        shippingMethod: {
                            method: defaultShippingMethod.key,
                            isValid: true,
                            isTouched: false
                        }
                    }));
                }
            }
        }
        dispatch(shippingMethodsSuccess({
            result: shippingMethodList
        }));
    }, [
        cart,
        dispatch,
        store1
    ]);
    const onShippingMethodLoadError = React.useCallback(()=>{
        dispatch(shippingMethodsFailed({
            message: 'Unable to load shipping methods'
        }));
    }, [
        dispatch
    ]);
    const { shippingMethodList: shippingMethodList1 , reloadShippingMethods , isLoading , error  } = useShippingMethodsList(onShippingMethodsLoadCompleted, onShippingMethodLoadError);
    const onError = React.useCallback(()=>{
        restoreShippingMethod();
        reloadShippingMethods();
    }, [
        reloadShippingMethods,
        restoreShippingMethod
    ]);
    const handleOnShippingMethodSelectSuccess = React.useCallback((shippingMethod)=>{
        if ((features === null || features === void 0 ? void 0 : features.isServiceStoreEnabled) && isPickupStore(shippingMethod) && selectedStore) {
            const serviceStore = {
                globalStoreId: selectedStore.globalStoreId,
                name: selectedStore.name,
                streetName: selectedStore.streetName,
                streetNumber: selectedStore.streetNumber,
                town: selectedStore.town
            };
            dispatch(selectServiceStore({
                serviceStore
            }));
        }
    }, [
        dispatch,
        features === null || features === void 0 ? void 0 : features.isServiceStoreEnabled,
        selectedStore
    ]);
    const { handleOnShippingMethodSelected  } = useShippingMethodSelection({
        shippingMethodList: shippingMethodList1 || [],
        onError,
        onSuccess: handleOnShippingMethodSelectSuccess
    });
    const onShippingMethodSelect = React.useCallback((method)=>{
        dispatch(selectShippingMethod({
            shippingMethod: {
                method: method,
                isValid: true,
                isTouched: true
            }
        }));
        switch(method){
            case ShippingMethod.Pickup:
                if (selectedStore) {
                    handleOnShippingMethodSelected(method, selectedStore.globalStoreId);
                }
                break;
            case ShippingMethod.PickupPoint:
                if (selectedPickupPoint) {
                    handleOnShippingMethodSelected(method);
                }
                break;
            default:
                handleOnShippingMethodSelected(method);
                break;
        }
    }, [
        dispatch,
        handleOnShippingMethodSelected,
        selectedPickupPoint,
        selectedStore
    ]);
    const onStoreSelect = React.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*(store) {
            const { globalStoreId  } = store;
            if ((selectedShippingMethod1 === null || selectedShippingMethod1 === void 0 ? void 0 : selectedShippingMethod1.method) && isPickupStore(selectedShippingMethod1 === null || selectedShippingMethod1 === void 0 ? void 0 : selectedShippingMethod1.method) && !isPickupStore(cart === null || cart === void 0 ? void 0 : cart.shippingMethod.key)) {
                dispatch(selectStore({
                    store
                }));
                yield handleOnShippingMethodSelected(selectedShippingMethod1 === null || selectedShippingMethod1 === void 0 ? void 0 : selectedShippingMethod1.method, globalStoreId);
            }
            if ((cart === null || cart === void 0 ? void 0 : cart.shippingMethod) && isPickupStore(cart.shippingMethod.key) && (selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.globalStoreId) !== globalStoreId) {
                dispatch(selectStore({
                    store
                }));
                yield handleOnShippingMethodSelected(cart === null || cart === void 0 ? void 0 : cart.shippingMethod.key, globalStoreId);
            }
        });
        return function(store) {
            return _ref.apply(this, arguments);
        };
    }(), [
        cart === null || cart === void 0 ? void 0 : cart.shippingMethod,
        dispatch,
        handleOnShippingMethodSelected,
        selectedShippingMethod1 === null || selectedShippingMethod1 === void 0 ? void 0 : selectedShippingMethod1.method,
        selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.globalStoreId, 
    ]);
    const onPickupPointSelect = React.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*(pickupPoint) {
            if (!pickupPoint) {
                return;
            }
            dispatch(selectPickupPoint({
                pickupPoint
            }));
            if ((selectedShippingMethod1 === null || selectedShippingMethod1 === void 0 ? void 0 : selectedShippingMethod1.method) && !isPickupPoint(cart === null || cart === void 0 ? void 0 : cart.shippingMethod.key)) {
                yield handleOnShippingMethodSelected(selectedShippingMethod1 === null || selectedShippingMethod1 === void 0 ? void 0 : selectedShippingMethod1.method);
            }
        });
        return function(pickupPoint) {
            return _ref.apply(this, arguments);
        };
    }(), [
        cart === null || cart === void 0 ? void 0 : cart.shippingMethod.key,
        dispatch,
        handleOnShippingMethodSelected,
        selectedShippingMethod1 === null || selectedShippingMethod1 === void 0 ? void 0 : selectedShippingMethod1.method, 
    ]);
    const handleClose = ()=>{
        restoreShippingMethod();
    };
    // If settings require explicit shipping method selection, invalidate and deselect shipping method on load
    React.useEffect(()=>{
        if (!(selectedShippingMethod1 === null || selectedShippingMethod1 === void 0 ? void 0 : selectedShippingMethod1.isTouched) && (selectedShippingMethod1 === null || selectedShippingMethod1 === void 0 ? void 0 : selectedShippingMethod1.isValid) && (shipping === null || shipping === void 0 ? void 0 : shipping.explicitShippingMethod)) {
            dispatch(selectShippingMethod({
                shippingMethod: {
                    method: undefined,
                    isValid: false,
                    isTouched: false
                }
            }));
        }
    }, [
        dispatch,
        selectedShippingMethod1 === null || selectedShippingMethod1 === void 0 ? void 0 : selectedShippingMethod1.isTouched,
        selectedShippingMethod1 === null || selectedShippingMethod1 === void 0 ? void 0 : selectedShippingMethod1.isValid,
        shipping === null || shipping === void 0 ? void 0 : shipping.explicitShippingMethod, 
    ]);
    if (!shippingMethodList1) return null;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "checkout-shipping-methods"
    }, /*#__PURE__*/ React.createElement(ShippingMethodsListContainer, {
        asides: shippingMethodsAsides,
        selectedShippingMethod: selectedShippingMethod1,
        shippingMethodList: shippingMethodList1,
        handleOnShippingMethodSelected: onShippingMethodSelect,
        isLoading: isLoading,
        error: error
    })), /*#__PURE__*/ React.createElement(SelectedShippingMethodContainer, {
        selectedShippingMethod: selectedShippingMethod1 === null || selectedShippingMethod1 === void 0 ? void 0 : selectedShippingMethod1.method,
        onStoreSelect: onStoreSelect,
        selectedStore: selectedStore,
        onPickupPointSelect: onPickupPointSelect,
        selectedPickupPoint: selectedPickupPoint,
        onShippingModalClose: handleClose
    }));
};

export { ShippingMethods };
//# sourceMappingURL=ShippingMethods.js.map
